import React from 'react'
import '../styles/layout.css'



class ContactForm extends React.Component {

    state = {
        name: '',
        mobile_number: '',
        email: '',
        message: ''
    }

    sendForm = () => {
        // uri = 'https://pirhoalpha.com/admin/api/register/web/user/info/'
        // test_uri = 'http://192.168.0.5/admin/api/register/web/user/info/'

        fetch('https://pirhoalpha.com/admin/api/register/web/user/info/', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(this.state)
        }).then((result) => {
            alert('Message Sent')
        })


    }

    handleName = (event) => {
        this.setState({ name: event.target.value })
    }
    handleEmail = (event) => {
        this.setState({ email: event.target.value })
    }
    handleContact = (event) => {
        this.setState({ mobile_number: event.target.value })
    }
    handleMessage = (event) => {
        this.setState({ message: event.target.value })
    }

    render() {

        return (
            <div className='form__container'>
                <form className={this.props.form ? 'form' : 'form__close'}>
                    <button type='button' onClick={() => {
                        this.props.closeForm()
                    }} style={{ marginLeft: "90%", background: '#499b87', border: 0, color: 'white', borderRadius: 5 }}>x</button> <br />
                    Name (required) <br />
                    <input onChange={
                        this.handleName

                    } type='text' value={this.state.name} /> <br />
                    Email (required) <br />
                    <input value={this.state.email} onChange={
                        this.handleEmail
                    } type='email' /> <br />
                    Contact Number (required) <br />
                    <input value={this.state.mobile_number} onChange={
                        this.handleContact} type='tel' /> <br />
                    Message <br />
                    <input value={this.state.message} onChange={this.handleMessage
                    } type='text' /> <br />
                    <button type='button' style={{ background: '#499b87', color: 'white', border: 0, width: "78%", marginTop: '0.5rem' }} onClick={() => {
                        this.sendForm()
                    }}>Submit</button>
                </form>
            </div>

        )


    }


}

export default ContactForm